import { render } from "./AlgorithmView-old.vue?vue&type=template&id=786d2773&scoped=true"
import script from "./AlgorithmView-old.vue?vue&type=script&lang=js"
export * from "./AlgorithmView-old.vue?vue&type=script&lang=js"

import "./AlgorithmView-old.vue?vue&type=style&index=0&id=786d2773&scoped=true&lang=css"

import exportComponent from "/app/websites/dizztinct/dizztinct-patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-786d2773"]])

export default __exports__